import _ from 'underscore';

export function getVerifiedTrackingSettings(model) {
  const verifiedTrackingSettings = _.get(model, 'VerifiedTrackingSettings');

  if (!verifiedTrackingSettings || verifiedTrackingSettings.length === 0) {
    return {};
  }
  const results = [];

  verifiedTrackingSettings.forEach((setting) => {
    const vendor = _.get(setting, 'VerifiedTrackingVendor');

    if (!_.isString(vendor)) {
      return;
    }

    if (!_.isEqual(vendor, 'IAS') && !_.isEqual(vendor, 'MOAT')) {
      return;
    }

    const result = {};

    result.vendorName = vendor;
    if (_.isEqual(vendor, 'MOAT')) {
      results.push(result);
      return;
    }

    const data = _.get(setting, 'VerifiedTrackingData[0].Data');

    if (!_.isObject(data) || _.isEmpty(data)) {
      return;
    }

    const keys = _.get(data, 'Keys');

    if (!_.isArray(keys) || _.isEmpty(keys)) {
      return;
    }

    const values = _.get(data, 'Values');

    if (!_.isArray(values) || _.isEmpty(values)) {
      return;
    }

    const keyMap = { IAS_advertiserEntityId: 'advertiserEntityId', IAS_publisherEntityId: 'publisherEntityId' };


    _.each(keys, (key, index) => {
      if (keyMap[key]) {
        result[keyMap[key]] = values[index];
      }
    });
    results.push(result);
  });

  return { VerifiedTrackingSettings: results };
}
